import { connect } from 'react-redux';

import { STATUSES, SECTION_ID_FORECAST } from 'legacy/appstore/constants';

import { buildChartConfigForecast } from 'legacy/utils/chart-configs';

import { reportChangeForecastAreaType } from 'actions/property-explorer';
import { saveReport } from 'actions/edit-report';

import {
  getForecastChartDataSelected,
  getForecastChartHasBlockData,
  getForecastChartHasZipData
} from 'selectors/chart-data';
import { getForecastChartAreaType } from 'selectors/property-explorer';
import { getAvmSelectedKey } from 'selectors/avms';
import { getReportStatusForecast } from 'selectors/report-status';

import loadWhenReady from 'legacy/hocs/loadWhenReady';

import PropertyExplorerForecastChart from 'legacy/components/PropertyExplorerForecastChart';

const mapStateToProps = (state, ownProps) => {
  const forecastChartAreaType = getForecastChartAreaType(state);
  const forecastChartData = getForecastChartDataSelected(state);
  const avmKey = getAvmSelectedKey(state);
  const status = getReportStatusForecast(state);
  const isLoading = status !== STATUSES.SUCCESS && status !== STATUSES.ERROR;
  return {
    areaType: forecastChartAreaType,
    hasErrored: status === STATUSES.ERROR,
    // These checks use the or operator so we don't show NullStateCard during loading
    hasDataBlock: isLoading || getForecastChartHasBlockData(state),
    hasDataZip: isLoading || getForecastChartHasZipData(state),
    calloutData: forecastChartData.forecast,
    chartConfig: buildChartConfigForecast(
      forecastChartData,
      forecastChartAreaType,
      avmKey
    ),
    isLoading
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleChangeAreaType: (areaType, hasData) => {
    dispatch(reportChangeForecastAreaType(areaType));
    if (hasData) {
      dispatch(saveReport(true));
    }
  }
});

const PropertyExplorerForecastChartContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(loadWhenReady(PropertyExplorerForecastChart, SECTION_ID_FORECAST));

export default PropertyExplorerForecastChartContainer;
